// Module
var code = `<div class="col-lg-12">
    <bfg-chart name="runner_battler.RbChurnByMissionChart"></bfg-chart>
</div>
`;
// Exports
module.exports = code;